// @flow
import authLogout from '../auth/logout'

/**
 * Logout an user
 * @return {void}
 */
export const logout = () => {
  authLogout()
}

export default logout
